import React, { useEffect, useMemo } from "react";
import { TagsInput } from "@cadmakers-ui/core";
import { User, useUsers } from "../../..";

type Props = {
  selectedIds: number[];
  onSelectedUsersChange: (users: User[]) => void;
};

type TagsInputItem = {
  value: string | number;
  label: string;
};

const MultiUserSelector: React.FC<Props> = props => {
  const users = useUsers();

  const userOptions = useMemo(() => {
    if (!users.loadingState.isLoaded) {
      return [];
    }

    return users.users.map(u => ({
      value: u.id,
      label: u.name
    }));
  }, [users]);

  const selectedValues = useMemo(() => {
    return userOptions.filter(t => props.selectedIds.includes(t.value));
  }, [props.selectedIds, userOptions]);

  const onTagsInputChange = (newValue: TagsInputItem | TagsInputItem[]) => {
    if (!newValue) {
      props.onSelectedUsersChange([]);
    } else if (Array.isArray(newValue)) {
      const selectedUserIds = newValue.map(v => v.value as number);
      const selectedUsers = users.users.filter(u => selectedUserIds.includes(u.id));
      props.onSelectedUsersChange(selectedUsers);
    } else {
      props.onSelectedUsersChange([users.users.find(u => u.id === newValue.value) as User]);
    }
  };

  return <TagsInput options={userOptions} value={selectedValues} onChange={onTagsInputChange} />;
};

export default MultiUserSelector;
